export default __webpack_public_path__ + "static/media/ChildrenDay_04.816151f7.png";